import type { DemoKey } from './keys';

export const pa: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ਗਣਿਤ · 3D ਜਿਓਮੈਟਰੀ',
  'panel.figure': 'ਆਕਾਰ',
  'panel.dims': 'ਆਯਾਮ',
  'panel.style': 'ਦਿੱਖ',
  'panel.lines': 'ਵਿਸ਼ੇਸ਼ ਰੇਖਾਵਾਂ',
  'style.body': 'ਵਸਤੂ',
  'style.line': 'ਰੇਖਾ',
  'style.cut': 'ਖੰਡ',
  'style.labels': 'ਸਿਖਰ ਲੇਬਲ',
  'group.face': 'ਮੁਖ ਵਿਕਰਨ / ਜਨਕ',
  'group.space': 'ਵਿਕਰਨ / ਅਕਸ਼ / ਮਾਧਿਅਕਾ',
  'split.label': 'ਖੰਡ',
  'btn.animate': 'ਚਲਾਓ',
  'btn.reset': 'ਰੀਸੈੱਟ',
  'hint.line1': 'ਘੁਮਾਉਣ ਲਈ ਖਿੱਚੋ · ਜ਼ੂਮ ਲਈ ਸਕ੍ਰੌਲ ਕਰੋ',
  'hint.line2': 'ਚੁਣਨ ਲਈ ਰੇਖਾ ਉੱਤੇ ਕਲਿੱਕ ਕਰੋ',
  'fig.cuboid': 'ਘਨਾਭ',
  'fig.cube': 'ਘਣ',
  'fig.triPrism': 'ਤ੍ਰਿਭੁਜਾਕਾਰ ਪ੍ਰਿਜ਼ਮ',
  'fig.hexPrism': 'ਛੇਭੁਜਾਕਾਰ ਪ੍ਰਿਜ਼ਮ',
  'fig.tetrahedron': 'ਚਤੁਰਮੁਖ',
  'fig.squarePyramid': 'ਵਰਗਾਕਾਰ ਪਿਰਾਮਿਡ',
  'fig.cylinder': 'ਬੇਲਨ',
  'fig.cone': 'ਸ਼ੰਕੁ',
  'fig.sphere': 'ਗੋਲਾ',
  'fig.frustumPyramid': 'ਪਿਰਾਮਿਡ ਦਾ ਛਿੰਨਕ',
  'fig.frustumCone': 'ਸ਼ੰਕੁ ਦਾ ਛਿੰਨਕ',
  'dim.length': 'ਲੰਬਾਈ',
  'dim.width': 'ਚੌੜਾਈ',
  'dim.height': 'ਉਚਾਈ',
  'dim.side': 'ਭੁਜਾ',
  'dim.radius': 'ਅਰਧ-ਵਿਆਸ',
  'dim.r1': 'ਹੇਠਲਾ ਅਰਧ-ਵਿਆਸ',
  'dim.r2': 'ਉੱਪਰਲਾ ਅਰਧ-ਵਿਆਸ',
  'dim.sideBase': 'ਆਧਾਰ ਭੁਜਾ',
  'dim.sideTop': 'ਉੱਪਰਲੀ ਭੁਜਾ',
  'info.face': 'ਮੁਖ',
  'info.center': 'ਕੇਂਦਰ ਵਿੱਚੋਂ',
  'info.diagonal': 'ਵਿਕਰਨ',
  'info.axial': 'ਅਕਸ਼ੀ ਵਿਕਰਨ',
  'info.diameter': 'ਵਿਆਸ',
  'info.generator': 'ਜਨਕ',
  'info.axis': 'ਅਕਸ਼',
  'info.height': 'ਉਚਾਈ',
  'info.median': 'ਮਾਧਿਅਕਾ',
  'info.apothem': 'ਅਪੋਥਮ',
  'info.diameterBase': 'ਆਧਾਰ ਵਿਆਸ',
  'info.diameterTop': 'ਉੱਪਰਲਾ ਵਿਆਸ',
};
